import deepClone from 'foundation/js/deepClone'
import { globalFetch } from "foundation/js/api"
import store from '../index.js'

const defaultFirstPageSize = 25
const defaultShowMorePageSize = 25
export default {
    namespaced: true,
    state: {
        is_searching: false,
        facets: {},
        populated_facet_ids: [],
        queries: {},
        results: {},
        sorting: {},
        show_results: {},
        search_inprogress: {},
        more_search_inprogress: {},
        firstPageSize: {},
        showMorePageSize: {},
        skip_take: {},
        scoped_total: {},
        urls: {},
        replaceQueryInUrl: true,
        search_overlay_scope: undefined,
        filter_overlay_scopes: undefined,
        search_page_redirecturl: undefined,
        autocomplete_result: {},
        autocomplete_inprogress: {},
        hide_autocomplete: false,
        dictionary_data: []
    },
    mutations: {
        set_is_searching(state,boolean){
            state.is_searching = boolean
        },
        set_dictionary_data(state,data){
            state.dictionary_data = data
        },
        set_replaceQueryInUrl(state, bool) {
            state.replaceQueryInUrl = bool
        },
        set_search_page_redirecturl(state, url) {
            state.search_page_redirecturl = url
        },
        set_filter_overlay_scopes(state, guids) {
            state.filter_overlay_scopes = guids
        },
        set_scoped_result(state, config) {
            state.results[config.scope.guid] = config.data
        },
        add_populated_facet_ids(state, config) {
            state.populated_facet_ids = state.populated_facet_ids.concat(
                config.data
            )
        },
        add_scoped_result(state, config) {
            state.results[config.scope.guid] = state.results[
                config.scope.guid
            ].concat(config.data)
        },
        set_scoped_total(state, config) {
            state.scoped_total[config.scope.guid] = config.data
        },
        set_scoped_facets(state, config){
            state.facets[config.scope.guid] = config.data
        },
        show_results(state, guid) {
            state.show_results[guid] = true
        },
        begin_search(state, guid) {
            state.search_inprogress[guid] = true
        },
        complete_search(state, guid) {
            state.search_inprogress[guid] = false
        },
        new_scope(state, scope) {
            state.search_inprogress[scope.guid] = false
            state.show_results[scope.guid] = false
            state.queries[scope.guid] = scope.query
            state.firstPageSize[scope.guid] =
                scope.firstPageSize ?? defaultFirstPageSize
            state.showMorePageSize[scope.guid] =
                scope.showMorePageSize ?? defaultShowMorePageSize
            state.skip_take[scope.guid] = {
                skip: scope.skip,
                take: scope.take
            }
            state.urls[scope.guid] = scope.url
                ? scope.url
                      .replace('[guid]', scope.guid)
                      .replace('[pageId]', store.state.main.page_id)
                : scope.url
            state.scoped_total[scope.guid] = 0
            state.sorting[scope.guid] = scope.sorting
        },
        set_scoped_query(state, scope) {
            state.queries[scope.guid] = scope.query
        },
        set_scoped_skip_take(state,scope) {
            state.skip_take[scope.guid] = {
                skip: parseInt(scope.skip ?? 0),
                take: parseInt(scope.take ?? state.firstPageSize[scope.guid])
            }
        },
        begin_autocomplete(state) {
            state.autocomplete_inprogress = true
        },
        set_autocomplete_result(state, config) {
            state.autocomplete_result = config.data
        },
        set_hide_autocomplete(state, bool) {
            state.hide_autocomplete = bool
        },
        set_sorting_value(state, scope) {
            state.sorting[scope.guid] = scope.sorting
        },
        complete_autocomplete(state) {
            state.autocomplete_inprogress = false
        },
        begin_more_search(state, guid) {
            state.more_search_inprogress[guid] = true
        },
        complete_more_search(state, guid) {
            state.more_search_inprogress[guid] = false
        }
    },
    actions: {
        patch_scoped_facets(context, scope) {
            if (!scope.facet) return
            const scopedFacets = deepClone(
                context.getters['getFacets'](scope.guid)
            )
            scopedFacets.forEach((facetGroup) => {
                const facet = facetGroup.facetValues.find(
                    (facetValue) => facetValue.facetId === scope.facet.facetId
                )
                if (facet) facet.selected = !facet.selected
            })
            context.state.facets[scope.guid] = scopedFacets
        },
        setSearchQuery(context, scope) {
            context.commit('set_scoped_query', scope)
        },
        initSearchScope(context, scope) {
            const url = new URL(window.location.href)

            scope.skip = parseInt(url.searchParams.get('skip')) || null
            scope.take = parseInt(url.searchParams.get('take')) || null
            scope.query = url.searchParams.get('q')
            scope.sorting = url.searchParams.get('sorting')

            const facetParams = []
            url.searchParams.forEach((value, key) => {
                const facetGroupId = parseInt(key)
                if (facetGroupId) {
                    facetParams.push({ facetGroupId: key, facetId: value })
                }
            })

            const groupedFacetParams = facetParams.reduce(
                (acc, { facetGroupId, facetId }) => {
                    acc[facetGroupId] = acc[facetGroupId] || []
                    acc[facetGroupId].push({ facetId })
                    return acc
                },
                {}
            )
            const facets = Object.keys(groupedFacetParams).map((k) => ({
                facetGroupId: k,
                facetValues: groupedFacetParams[k].map((g) => ({
                    facetId: g.facetId,
                    selected: true
                }))
            }))

            context.commit('new_scope', scope)
            context.commit('set_scoped_facets', { scope, data: facets })
            context.commit('set_scoped_result', { scope, data: [] })
        },
        performSearch(context, scope) {
            return new Promise((resolve,reject) => {
                if (!context.state.urls[scope.guid]) 
                {
                    reject()
                }
                else
                {
                    context.commit('set_scoped_query', scope)
                    context.commit('set_scoped_skip_take', scope)
                    context.commit('show_results', scope.guid)
                    context.commit('begin_search', scope.guid)
                    context.commit('set_sorting_value', scope)
                    
                    context.dispatch('patch_scoped_facets', scope)
                    
                    context.commit("set_is_searching", true)
                    
                    const fetchConfig = context.getters.searchRequestGET(scope)
                    globalFetch(fetchConfig)
                    .then((res) => {
                        if (res.ok) return res.json()
                            context.commit("set_is_searching", false)
                        throw new Error('Search failed')
                        })
                        .then((json) => {
                            context.commit('set_scoped_result', {
                                scope,
                                data: json.hits
                            })
                            context.commit('set_scoped_facets', {
                                scope,
                                data: json.facets
                            })
                            context.commit('set_scoped_total', {
                                scope,
                                data: json.totalHits
                            })

                            if (context.state.replaceQueryInUrl) {
                                history.replaceState(
                                    {},
                                    'search',
                                    context.getters.getUrlQuery(scope)
                                )
                            }
                            context.commit("set_is_searching", false)
                            resolve(json)
                        })
                        .catch(err => {
                            console.error(err)
                            context.commit("set_is_searching", false)
                            reject(err)
                        })
                        .finally(() => {
                            context.commit("set_is_searching", false)
                            context.commit('complete_search',scope.guid)
                        })
                }
            })
        },
        performZeroSearch(context, scope) {
            if (context.state.urls[scope.guid]) {
                context.commit('begin_search', scope.guid)
                const fetchConfig = new Request(
                    context.getters.getBaseSearchUrl(scope)
                )
                globalFetch(fetchConfig)
                    .then((res) => {
                        if (res.ok) return res.json()
                        throw new Error('Search failed')
                    })
                    .then((data) => {
                        const nonEmptyFacetIds = data.facets.reduce(
                            (result, facetGroup) => {
                                const facetIdsWithCount = facetGroup.facetValues
                                    .filter(
                                        (facetValue) => facetValue.count > 0
                                    )
                                    .map((facetValue) => facetValue.facetId)

                                return result.concat(facetIdsWithCount)
                            },
                            []
                        )

                        context.commit('add_populated_facet_ids', {
                            data: nonEmptyFacetIds
                        })
                    })
                    .catch((err) => console.error(err))
                    .finally(() =>
                        context.commit('complete_search', scope.guid)
                    )
            }
        },
        performMoreSearch(context, scope) {
            context.commit('begin_more_search', scope.guid)
            context.commit("set_is_searching", true)
            const skip_take = context.getters.skip_take(scope.guid)
            const take = context.getters.showMorePageSize(scope.guid)
            const skip = parseInt(skip_take.skip) + parseInt(skip_take.take)
            context.commit('set_scoped_skip_take', { ...scope, skip, take })
            const fetchConfig = context.getters.searchRequestGET(scope)

            if (context.state.replaceQueryInUrl) {
                history.replaceState(
                    {},
                    'search',
                    context.getters.getUrlQuery(scope)
                )
            }

            globalFetch(fetchConfig)
                .then((res) => {
                    if (res.ok) return res.json()
                    throw new Error('Search failed')
                })
                .then((json) => {
                    context.commit('add_scoped_result', {
                        scope,
                        data: json.hits
                    })
                })
                .catch((err) => console.error(err))
                .finally(() => {
                    context.commit('complete_more_search', scope.guid)
                    context.commit("set_is_searching", false)
                })
        },
        refreshSearches(context) {
            let searchGuids = Object.keys(context.state.results)
            searchGuids.forEach(g => { 
                let scope = {
                    guid: g
                }
                context.dispatch('performSearch', scope)
            })
        },
        initAutocomplete(context, scope) {
            context.commit('set_autocomplete_result', { scope, data: {} })
        },
        getAutocomplete(context, scope) {
            context.commit('begin_autocomplete')
            const fetchConfig = context.getters.autocompleteRequestGET(scope)
            globalFetch(fetchConfig)
                .then((res) => {
                    if (res.ok) return res.json()
                    throw new Error('Search failed')
                })
                .then((json) => {
                    context.commit('set_autocomplete_result', {
                        scope,
                        data: json
                    })
                })
                .catch((err) => console.error(err))
                .finally(() =>
                    context.commit('complete_autocomplete', scope.guid)
                )
        }
    },
    getters: {
        getBaseSearchUrl: (state) => (scope) => {
            return `${document.location.origin}/${state.urls[scope.guid]}`
        },
        searchRequestGET: (state, getters) => (scope) => {
            const initialQueryParameters = []

            
            const urlParams = getters.getBaseSearchUrl(scope).split('?')[1]
            const urlParamsKeyValue = urlParams?.split('&').map((param) => param.split('='))

            if (urlParamsKeyValue?.length > 0) {
                urlParamsKeyValue.forEach((param) => {
                    initialQueryParameters.push([param[0], param[1]])
                })
            }

            const { skip, take } = state.skip_take[scope.guid]
            const sorting = state.sorting[scope.guid]

            if (skip) initialQueryParameters.push(['skip', skip])
            if (take) initialQueryParameters.push(['take', take])
            if (sorting) initialQueryParameters.push(['sorting', sorting])


            const query = state.queries[scope.guid]
                ? '?q=' + state.queries[scope.guid].toLowerCase() + '&'
                : '?'
            const facets = getters['getFacets'](scope.guid) ?? []
            const searchString =
                query +
                new URLSearchParams(
                    facets.reduce((body, facetGroup) => {
                        facetGroup.facetValues.forEach((facetValue) => {
                            if (!facetValue.selected) return false
                            body.push([
                                facetGroup.facetGroupId,
                                facetValue.facetId
                            ])
                        })
                        return body
                    }, initialQueryParameters)
                ).toString()

            const pageId = store.state.main.page_id
            const getUrl = (
                getters.getBaseSearchUrl(scope).split('?')[0] + searchString
            ).replace('[pageId]', pageId)


            console.log(
                'Searching on url...',
                new Request(getUrl).url.slice(
                    new Request(getUrl).url.indexOf('?')
                )
            )
            return new Request(getUrl)
        },
        autocompleteRequestGET: () => (scope) => {
            const getUrl = `${document.location.origin}/${process.env.AUTOCOMPLETE}?q=${scope.query}`
            console.log(
                'Autocompleting requesting on url...',
                new Request(getUrl).url.slice(
                    new Request(getUrl).url.indexOf('?')
                )
            )
            return new Request(getUrl)
        },
        getUrlQuery: (state, getters) => (scope) => {
            const url = new URL(document.location.href)

            const { skip, take } = state.skip_take[scope.guid]
            const sorting = state.sorting[scope.guid]
            const queries = state.queries[scope.guid]

            if (take) url.searchParams.set('take', skip + take)
            else url.searchParams.delete('take')

            if (sorting) url.searchParams.set('sorting', sorting)
            else url.searchParams.delete('sorting')

            if (queries) url.searchParams.set('q', queries)
            else url.searchParams.delete('q')

            // We need to delete previously sat facet/tags
            url.searchParams.forEach((value, key) => {
                if (parseInt(key)) url.searchParams.delete(key)
            })

            // We set the list of tags from our search
            const facets = getters['getFacets'](scope.guid) ?? []
            facets.forEach((f) => {
                f.facetValues.forEach((v) => {
                    if (!v.selected) return
                    url.searchParams.set(f.facetGroupId, v.facetId)
                })
            })

            return url.toString()
        },
        getFacets: (state) => (guid) => {
            if (!state.facets[guid]) return []

            const facets = []
            for (let facetGroup of state.facets[guid]) {
                const filteredFacetValues = facetGroup.facetValues.filter(
                    (facetValue) =>
                        facetValue.selected ||
                        state.populated_facet_ids.includes(facetValue.facetId)
                )

                if (filteredFacetValues.length === 0) continue

                const newFacetGroup = {
                    ...facetGroup,
                    facetValues: filteredFacetValues
                }

                facets.push(newFacetGroup)
            }

            return facets
        },
        allPrimaryTags: (_state, getters) => (guid) => {
            return getters['getFacets'](guid)?.find(
                (facetGroup) => facetGroup.facetGroupType === 'Primary'
            )?.facetValues
        },
        selectedTags: (_state, getters) => (guid) => {
            return getters['getFacets'](guid)
                ?.reduce((acc, f) => acc.concat(f.facetValues), [])
                .filter((f) => f.selected)
        },
        skip_take: (state) => (guid) => {
            return state.skip_take[guid]
        },
        showMorePageSize: (state) => (guid) => {
            return state.showMorePageSize[guid]
        },
        dictionaryData: (state) => {
            return state.dictionary_data
        },
        dictionaryFilterBySearch: (state) => {
            const term = state.queries.dictionarySearch
            return deepClone(state.dictionary_data)
                .map((group) => {
                    if (!term) return group

                    group.words = group.words.filter((word) =>
                        word.word.toLowerCase().includes(term.toLowerCase())
                    )
                    return group
                })
                .filter((group) => group.words.length)
        },
        canShowMore: (state) => (guid) => {
            var skipTake = state.skip_take[guid]
            return (
                skipTake &&
                skipTake.skip + skipTake.take < state.scoped_total[guid]
            )
        }
    }
}
